'use client'

import Script from 'next/script'
import { useTermlyConsent } from './useTermlyConsent'

interface ConsentBasedSnapchatPixelProps {
  pixelId: string
  debug?: boolean
}

export function ConsentBasedSnapchatPixel({
  pixelId,
  debug = false
}: ConsentBasedSnapchatPixelProps) {
  const hasConsent = useTermlyConsent(debug)

  if (!hasConsent) {
    return null
  }

  return (
    <Script
      id="snapchat-pixel-script"
      data-testid="snapchat-pixel-script"
      data-category="advertising"
      strategy="afterInteractive"
    >
      {`
        (function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
        {a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
        a.queue=[];var s='script',r=t.createElement(s);r.async=!0;
        r.src=n;var u=t.getElementsByTagName(s)[0];
        u.parentNode.insertBefore(r,u);})(window,document,
        'https://sc-static.net/scevent.min.js');
        snaptr('init', ${JSON.stringify(pixelId)});
        snaptr('track', 'PAGE_VIEW');
      `}
    </Script>
  )
}

export default ConsentBasedSnapchatPixel
